import {
    TEAM_PATCH_FAILURE,
    TEAM_PATCH_REQUEST,
    TEAM_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const patchReducer = (state = initialState, action) => {
    const {type, team} = action;
    switch (type) {
        case TEAM_PATCH_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            team,
        }}

        case TEAM_PATCH_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case TEAM_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
